import { render, staticRenderFns } from "./ComparisonGroupEditor.vue?vue&type=template&id=d036707e&scoped=true&"
import script from "./ComparisonGroupEditor.vue?vue&type=script&lang=ts&"
export * from "./ComparisonGroupEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ComparisonGroupEditor.vue?vue&type=style&index=0&id=d036707e&lang=scss&scoped=true&"
import style1 from "./ComparisonGroupEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d036707e",
  null
  
)

export default component.exports